import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        VRow,
        { attrs: { lass: "justify-start ml-2 mr-2" } },
        [
          _c(
            VCol,
            { attrs: { cols: "12", md: "6", sm: "12" } },
            [
              _c(
                VTooltip,
                {
                  attrs: { "max-width": "500", top: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on }) {
                        return [
                          _c(
                            "div",
                            _vm._g({}, on),
                            [
                              _c("select-simple-unidade", {
                                attrs: {
                                  value: _vm.unidade,
                                  "lista-unidades": _vm.unidades,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("div", [
                    _vm._v(
                      "Selecione para carregar os dados de outra unidade."
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.relatorio
        ? _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c(_vm.tipoMonitoramento, {
                    tag: "component",
                    attrs: { relatorio: _vm.relatorio, ano: `${_vm.anoAtual}` },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }